import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {AdhocService} from "../../services/adhoc.service";
import {ADHOC_LOAD_BANKING_INFO, ADHOC_PROCESS_EXPENSES} from "../action/adhoc.action";
import {catchError, mergeMap, of} from "rxjs";
import {show_error_action, show_success_msg_action} from "../action/common/common.action";

@Injectable()
export class AdhocEffect {
  constructor(private actions$: Actions, private adhocService: AdhocService) {}

  adhoc_load_banking_info$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ADHOC_LOAD_BANKING_INFO),
      mergeMap(() =>
        this.adhocService.callAdhocBankingInfoAPI().pipe(
          mergeMap(response => [
            show_success_msg_action({
              msg: "Adhoc banking information load triggered successfully."
            })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  adhoc_process_expenses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ADHOC_PROCESS_EXPENSES),
      mergeMap(action =>
        this.adhocService.callAdhocProcessExpensesAPI(action.request, action.file).pipe(
          mergeMap(response => [
            show_success_msg_action({
              msg: "Adhoc processing of expenses triggered successfully."
            })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
